/* tslint:disable */
/* eslint-disable */
/**
 * OSB Workspaces manager API
 * Opensource Brain Platform - Reference Workspaces manager API
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ResourceBase,
    ResourceBaseFromJSON,
    ResourceBaseFromJSONTyped,
    ResourceBaseToJSON,
} from './';

/**
 * Download Resource (files/folders)
 * @export
 * @interface DownloadResource
 */
export interface DownloadResource {
    /**
     * file name
     * @type {string}
     * @memberof DownloadResource
     */
    name?: string;
    /**
     * Download URL of the Resource
     * @type {string}
     * @memberof DownloadResource
     */
    path?: string;
}

export function DownloadResourceFromJSON(json: any): DownloadResource {
    return DownloadResourceFromJSONTyped(json, false);
}

export function DownloadResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): DownloadResource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'path': !exists(json, 'path') ? undefined : json['path'],
    };
}

export function DownloadResourceToJSON(value?: DownloadResource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'path': value.path,
    };
}


